<template>
  <b-card
    no-body
    class=" border border-2 h-100"
  >
    <div class="flex justify-between items-start mb-1 px-1 pt-1">
      <div>
        <div class="font-semibold text-[16px] text-black">
          Log Activity
        </div>
        <div class="text-[#A0A0A0] text-[12px]">
          Last 5 data agent created & closing order
        </div>
      </div>
      <div>
        <button
          class="border border-[#ced4da] rounded-md px-1 py-[7px] text-[13px] bg-white text-black hover:bg-gray-50 transition-colors"
          @click="$bvModal.show('modal-log-activity')"
        >
          Lihat Semua
        </button>
      </div>
    </div>

    <div class="px-1 flex flex-col gap-1 ">
      <div
        v-for="(log, idx) in logs"
        :key="idx"
        class="border border-gray-200 rounded-lg p-[8px] mb-1 flex justify-between items-center bg-white"
      >
        <div class="flex items-center gap-1">
          <img
            :src="log.type === 'agent' ? 'https://storage.googleapis.com/komerce/assets/icons/icons/person-blue.png' : 'https://storage.googleapis.com/komerce/assets/icons/icons/bag-check.png'"
            alt="icon"
          >
          <div class="ml-1">
            <div class="text-black font-medium text-[14px] m-0 p-0 leading-tight">
              {{ log.title }}
            </div>
            <div class="text-[#A0A0A0] text-[12px] m-0 p-0 mt-[6px]">
              Dibuat oleh {{ log.author }}
            </div>
          </div>
        </div>
        <div class="text-right shrink-0 ml-1">
          <div class="text-black text-[13px] m-0 p-0 leading-tight">
            {{ log.date }}
          </div>
          <div class="text-[#A0A0A0] text-[12px] m-0 p-0 mt-[4px]">
            {{ log.time }}
          </div>
        </div>
      </div>
    </div>

    <!-- Component Modal -->
    <LogActivityModal />
  </b-card>
</template>

<script>
import moment from 'moment'
import {
  START_DATE_OF_MONTH,
  END_DATE_OF_MONTH,
  DDMMYYYY,
  TIME,
} from '@/libs/filterDate'
import LogActivityModal from './LogActivityModal.vue'
import { apiDataActivity } from '../services/api.komchat.service'

export default {
  name: 'LogActivity',
  components: {
    LogActivityModal,
  },
  data() {
    return {
      logs: [],
    }
  },
  mounted() {
    this.fetchLogs()
  },
  methods: {
    async fetchLogs() {
      const startDate = START_DATE_OF_MONTH(moment())
      const endDate = END_DATE_OF_MONTH(moment())

      try {
        const res = await apiDataActivity({
          startDate,
          endDate,
          eventType: '',
          limit: 5,
          offset: 0,
        })
        if (res && res.data && res.data.data) {
          const { details } = res.data.data
          this.logs = (details || []).map(log => {
            const isAgent = log.event_type === 'agent'
            const title = isAgent
              ? `Agent Customer Service ${log.agent_name || ''} Dibuat`
              : log.closing || '-'
            return {
              type: isAgent ? 'agent' : 'order',
              title,
              author: log.partner_name || '-',
              date: DDMMYYYY(log.timestamp),
              time: TIME(log.timestamp),
            }
          })
        } else {
          this.logs = []
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch activity logs', err)
      }
    },
  },
}
</script>
